var _circle, _circle2, _circle3, _circle4, _circle5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNigeriaLabourCongress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48,
    fill: "#ffffff",
    stroke: "#dc2626",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 40,
    fill: "#dc2626"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 35,
    fill: "#ffffff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 15,
    fill: "#dc2626"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 8,
    fill: "#ffffff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 30,
    width: 4,
    height: 8,
    fill: "#dc2626"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 62,
    width: 4,
    height: 8,
    fill: "#dc2626"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 48,
    width: 8,
    height: 4,
    fill: "#dc2626"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 48,
    width: 8,
    height: 4,
    fill: "#dc2626"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 36,
    width: 6,
    height: 6,
    fill: "#dc2626",
    transform: "rotate(45 39 39)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 36,
    width: 6,
    height: 6,
    fill: "#dc2626",
    transform: "rotate(-45 61 39)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 58,
    width: 6,
    height: 6,
    fill: "#dc2626",
    transform: "rotate(-45 39 61)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 58,
    width: 6,
    height: 6,
    fill: "#dc2626",
    transform: "rotate(45 61 61)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 80,
    textAnchor: "middle",
    fontFamily: "Arial",
    fontSize: 7,
    fill: "#dc2626",
    fontWeight: "bold"
  }, "NLC")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigeriaLabourCongress);
export default __webpack_public_path__ + "static/media/nigeria-labour-congress.c9d921960c565191912347c909d1e6f1.svg";
export { ForwardRef as ReactComponent };